<script type="text/javascript">
  window.extAsyncInit = function() {
    // the Messenger Extensions JS SDK is done loading
    // console.log('the Messenger Extensions JS SDK is done loading');
    // the Messenger Extensions JS SDK is done loading
    // MessengerExtensions.getUserID(function success(uids) {
    //   var psid = uids.psid;
    // }, function error(err) {
    //   alert("Messenger Extension Error: " + err);
    // });
  };
  window.closeWebView = function() {
    console.log('closing webview');
    MessengerExtensions.requestCloseBrowser(function success() {
      // webiewv closed
      alert('webiewv closed')
    }, function error(err) {
      // an error occurred
      //alert(err)
      window.top.close ();
    });
  };
</script>

<mat-drawer-container class="sidenav-container" (backdropClick)="close('backdrop')">
  <mat-drawer #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="'over'"
      [opened]="false">
<!--    <mat-toolbar>{{'my_club_connect' | GetLabelPipe}}</mat-toolbar>-->
    <mat-toolbar>{{'my' | GetLabelPipe}} {{application.account?.payload_parsed['connect_label']}}</mat-toolbar>
    <app-mobile-avatar *ngIf="application.user?.id" (click)="goToMyProfile()"></app-mobile-avatar>
    <hr>
    <mat-nav-list>
      <a mat-list-item (click)="goToMySchedule()" [class.menu-item-selected]="state==='my_schedule'" *ngIf="application.isTrainerLogin()">
        <mat-icon [class.menu-item-icon]="true">event</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'my_schedule' | GetLabelPipe}}</span>
      </a>
      <a mat-list-item (click)="goToUserBookings(application.user)" [class.menu-item-selected]="state==='user_view_bookings' && application.user?.id == this.viewID">
        <mat-icon [class.menu-item-icon]="true">history</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'my_bookings' | GetLabelPipe}}</span>
      </a>
<!--      <a mat-list-item (click)="goToUserFriends(application.user)" [class.menu-item-selected]="state==='user_view_friends' && application.user?.id == this.viewID">-->
<!--        <mat-icon [class.menu-item-icon]="true">sports_handball</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'my_trainers' | GetLabelPipe}}</span>-->
<!--      </a>-->
      <a mat-list-item (click)="goToUserFriends(application.user)" [class.menu-item-selected]="state==='user_view_friends' && application.user?.id == this.viewID">
        <mat-icon [class.menu-item-icon]="true">person</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'my_friends' | GetLabelPipe}}</span>
      </a>
      <a mat-list-item (click)="goToUserGroups(application.user)" [class.menu-item-selected]="state==='user_view_groups' && application.user?.id == this.viewID">
        <mat-icon [class.menu-item-icon]="true">groups</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'my_groups' | GetLabelPipe}}</span>
      </a>
      <a mat-list-item (click)="goToTrainers()" [class.menu-item-selected]="state==='trainers'" *ngIf="application.showAllTrainers()">
        <mat-icon [class.menu-item-icon]="true">perm_contact_calendar</mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'all_trainers' | GetLabelPipe}}</span>
      </a>
    </mat-nav-list>
    <hr>
    <mat-nav-list *ngIf="isTrainerLogin || (application.account && !application.account.payload_parsed['hide_connect_for_user'])">
<!--      <a mat-list-item (click)="goToState('squash_default')" [class.menu-item-selected]="state==='squash_default'">😎🎾&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'top_label_public' | GetLabelPipe}}</span></a>-->
      <a mat-list-item (click)="goToState('squash_default')" [class.menu-item-selected]="state==='squash_default'">😎{{application.account.payload_parsed['connect_game_icon']}}&nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{application.account.payload_parsed['connect_label']}}</span></a>
      <a mat-list-item (click)="goToState('subscribe_events')" [class.menu-item-selected]="state==='subscribe_events'">📢 &nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'top_label_events' | GetLabelPipe}}</span></a>
      <ng-container *ngIf="application.account.payload_parsed['has_cups']">
        <a mat-list-item (click)="goToState('cups')" [class.menu-item-selected]="state==='cups'">🏆 &nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'top_label_cups' | GetLabelPipe}}</span></a>
      </ng-container>
      <a mat-list-item (click)="goToState('classes')" [class.menu-item-selected]="state==='classes'">👥 &nbsp;&nbsp;&nbsp;<span class="menu-item-label">{{'players_groups' | GetLabelPipe}}</span></a>
    </mat-nav-list>
  </mat-drawer>
  <mat-drawer-content>
    <mat-toolbar color="primary" class="mobile-toolbar" *ngIf="!['liqpay_checkout'].includes(application.state)"
                 [class.hidden-final]="hideToolbar">
      <button *ngIf="['my_schedule','squash_default','subscribe_events','cups','classes','calendar','trainers'].includes(state) && application.user?.id"
        type="button"
        mat-icon-button
        (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>

      <button *ngIf="['class_view'].includes(state) && application.user?.id"
              [class.invisible-button]="hideBackButton"
              type="button"
              mat-icon-button
              (click)="goBack()">
              <mat-icon>arrow_back</mat-icon>
      </button>

      <button *ngIf="['user_view','user_view_bookings','user_view_groups','user_view_friends'].includes(state) && application.user?.id == this.viewID"
        type="button"
        mat-icon-button
        (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <button *ngIf="['user_view','user_view_bookings','user_view_groups','user_view_friends','trainer_booking'].includes(state) && application.user?.id != this.viewID"
        type="button"
        mat-icon-button
        (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button *ngIf="['profile_edit','trainer_view'].includes(state)"
              type="button"
              mat-icon-button
              (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <!-- empty button -->
      <button *ngIf="!['my_schedule','profile_edit'].includes(state) && !application.user?.id"
        type="button"
        mat-icon-button>
      </button>

<!--      <span *ngIf="state === 'squash_default'">{{'top_label_public' | GetLabelPipe}}</span>-->
      <span *ngIf="state === 'squash_default'">{{application.account?.payload_parsed['connect_label']}}</span>
      <span *ngIf="state === 'subscribe_events'">{{'top_label_events' | GetLabelPipe}}</span>
      <span *ngIf="state === 'cups'">{{'top_label_cups' | GetLabelPipe}}</span>
      <span *ngIf="state === 'classes'">{{'players_groups' | GetLabelPipe}}</span>
      <span *ngIf="state === 'calendar'">{{'my_calendar' | GetLabelPipe}}</span>
      <span *ngIf="state === 'trainers'">{{'club_trainers' | GetLabelPipe}}</span>
      <span *ngIf="state === 'trainers_widget'">{{'club_trainers' | GetLabelPipe}}</span>
      <span *ngIf="state === 'sms_login'"><ng-container *ngIf="application.user.id">{{'club_registration' | GetLabelPipe}}</ng-container></span>
<!--      <span *ngIf="state === 'trainer_booking'">{{'book_trainer' | GetLabelPipe}}</span>-->
      <span *ngIf="state === 'trainer_view'">{{'view_trainer' | GetLabelPipe}}</span>
      <span *ngIf="state === 'my_schedule'">{{'my_schedule' | GetLabelPipe}}</span>
      <span *ngIf="state === 'profile_edit'">{{'profile_edit' | GetLabelPipe}}</span>
      <span *ngIf="state === 'class_view'">{{'group_view' | GetLabelPipe}}</span>
      <span *ngIf="['user_view','user_view_bookings','user_view_groups','user_view_friends'].includes(state)">
        {{viewerStateLabel}}
      </span>
<!--      <span *ngIf="['user_view','user_view_bookings','user_view_groups','user_view_friends'].indexOf(state) !== -1 && application.user?.id != this.viewID">-->
<!--        {{'tbc' | GetLabelPipe}}-->
<!--      </span>-->

      <button *ngIf="['user_view','user_view_bookings','user_view_friends','user_view_groups'].includes(state) && application.user?.id == this.viewID"
        type="button"
        (click)="userActionButtonClick()"
        mat-icon-button>
        <mat-icon *ngIf="state==='user_view'">edit</mat-icon>
        <mat-icon *ngIf="state==='user_view_bookings'">event</mat-icon>
        <mat-icon *ngIf="state==='user_view_friends'">person_search</mat-icon>
        <mat-icon *ngIf="state==='user_view_groups'">group_add</mat-icon>
      </button>
      <button *ngIf="( state === 'user_view' && application.user?.id != this.viewID)"
        type="button"
        (click)="otherUserActionButtonClick()"
        mat-icon-button>
        <mat-icon *ngIf="!this.relationStatus">person_add</mat-icon>
        <mat-icon *ngIf="this.relationStatus">manage_accounts</mat-icon>
      </button>
      <div *ngIf="!['user_view','profile_edit','user_view_bookings','user_view_groups','user_view_friends','trainer_view','my_schedule','class_view'].includes(state)"
        style="width: 32px;">&nbsp;</div>
<!--      <div *ngIf="!(['user_view','user_view_bookings','user_view_groups','user_view_friends'].indexOf(state) !== -1 && application.user?.id == this.viewID || (['user_view','user_view_bookings','user_view_groups','user_view_friends'].indexOf(state) !== -1 && application.user?.id != this.viewID))"-->
<!--        style="width: 32px;">&nbsp;</div>-->

      <button *ngIf="['trainer_view'].includes(state)"
              [class.faded] = "!application.user?.id"
              type="button"
              (click)="addTrainerScheduleAction(this.viewID)"
              mat-icon-button>
        <mat-icon>event</mat-icon>
      </button>
      <button *ngIf="['my_schedule'].includes(state)"
              [class.faded] = "!application.user?.id"
              type="button"
              (click)="myScheduleAction()"
              mat-icon-button>
        <mat-icon>edit_calendar</mat-icon>
      </button>
      <button *ngIf="['profile_edit'].includes(state)"
              [class.faded] = "!application.user?.id"
              type="button"
              (click)="saveProfile()"
              mat-icon-button>
        <mat-icon>done</mat-icon>
      </button>
      <button *ngIf="['class_view'].includes(state)"
              [matMenuTriggerFor]="classMenu"
              type="button"
              mat-icon-button>
        <mat-icon>more_vert</mat-icon>
      </button>

    </mat-toolbar>
    <mat-toolbar color="primary" class="mobile-toolbar" *ngIf="['liqpay_checkout'].includes(application.state)">
      <section *ngIf="application.account && application.account.logo" style="width:100%; margin-top:0px; text-align: center;">
        <img src="{{application.account.logo}}" class="mobile-logo" alt="Account Logo" />
      </section>
    </mat-toolbar>
<!--    <app-mobile-avatar></app-mobile-avatar>-->
    <app-mobile-metrics *ngIf="false"></app-mobile-metrics>
    <app-liq-pay-widget *ngIf="application.state === 'liqpay_checkout'"></app-liq-pay-widget>

    <div class="screen-container" [class.handset-screen-container]="isHandset$ | async"
         [class.hidden-top-toolbar]="hideToolbar"
         *ngIf="['squash_default','subscribe_events','cups','classes','calendar','user_view','user_view_bookings','user_view_groups','user_view_friends','class_view','trainers','trainers_widget','sms_login','trainer_booking','trainer_view','my_schedule','profile_edit'].includes(state)">

      <div class="mobile-central-content"
           *ngIf="['squash_default','subscribe_events','cups','classes'].includes(state) && application.user?.id">
        <app-top-menu></app-top-menu>
        <app-group-events-list></app-group-events-list>
      </div>

      <div class="mobile-central-content"
           *ngIf="state === 'trainers' && application.user?.id">
        <app-simple-list></app-simple-list>
      </div>
      <div class="mobile-central-content" [class.hidden-exit-button]="hideExitButton"
           *ngIf="state === 'trainers_widget'">
        <app-simple-list></app-simple-list>
      </div>

<!--      <div class="mobile-central-content"-->
<!--           *ngIf="state === 'trainer_booking' && application.user?.id">-->
<!--        <app-trainer-details [viewID]="this.viewID"></app-trainer-details>-->
<!--      </div>-->
      <div class="mobile-central-content"
           *ngIf="state === 'trainer_view' && application.user?.id">
        <app-trainer-details [viewID]="this.viewID"></app-trainer-details>
      </div>
      <div class="mobile-central-content"
           *ngIf="state === 'my_schedule' && application.user?.id">
        <app-calendar-container [profile]="application.user" [allow_events_edit]="true"></app-calendar-container>
      </div>

      <div class="mobile-central-content" *ngIf="['user_view','user_view_bookings','user_view_groups','user_view_friends'].includes(state) && application.user?.id">
        <app-user-details-component [viewID]="this.viewID"></app-user-details-component>
      </div>
      <div class="mobile-central-content" *ngIf="state === 'profile_edit' && application.user?.id" [class.hidden-exit-button]="true">
        <app-profile-edit-component></app-profile-edit-component>
      </div>
      <div class="mobile-central-content" *ngIf="state === 'class_view' && application.user?.id" [class.hidden-exit-button]="hideExitButton">
        <app-class-details-component [viewID]="this.viewID"></app-class-details-component>
      </div>
      <!-- test calendar-->
      <div class="mobile-central-content" *ngIf="state === 'calendar' && application.user?.id">
        <app-calendar-container></app-calendar-container>
      </div>

      <div class="mobile-central-content" [class.hidden-exit-button]="hideExitButton"
           [class.flex-row-center]="!application.user?.id" [class.flex-justify-center]="!application.user?.id"
           *ngIf="state === 'sms_login'">
        <div class="internal-spinner internal-spinner-smaller" *ngIf="!application.userLoginChecked">
          <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
          </svg>
        </div>
        <app-login-form [application]="application" [initialState]="'sms_login'"
                        *ngIf="application.userLoginChecked && !application.user?.id"></app-login-form>
        <app-profile-edit-component
                        *ngIf="application.userLoginChecked && application.user?.id"></app-profile-edit-component>
      </div>
      <div class="mobile-central-content" *ngIf="!['trainers_widget','sms_login'].includes(state) && !application.user?.id">
        <div class="internal-spinner internal-spinner-smaller" *ngIf="!application.userLoginChecked">
          <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
          </svg>
        </div>
        <div *ngIf="application.userLoginChecked" class="empty-folder" fxLayout="column" fxLayoutAlign="center center">
          <mat-icon>account_box</mat-icon>
          <p>{{'session_expired' | GetLabelPipe}}</p>
          <p style="font-size: 18px; padding: 0px 12px;" [innerHTML]="'connect_session_restart' | GetLabelPipe"></p>
        </div>
      </div>

      <div class="messenger-button-container" *ngIf="!hideExitButton">
        <button type="submit" class="messenger-button" mat-raised-button color="accent"
                id="exit_button" (click)="exit()">
          {{'mobile_exit_default' | GetLabelPipe}}
        </button>
      </div>
      <app-notification-container></app-notification-container>
    </div>

  </mat-drawer-content>
</mat-drawer-container>

<mat-menu #classMenu="matMenu" class="file-menu">
  <ng-container *ngIf="classConfig && classConfig['provide_play_config_on_join'] && (isClassOwner || profileClassRelation == 'active')">
    <button mat-menu-item (click)="dispatchClassMenuEvent('my_play_conf')">
      <mat-icon>sports_cricket</mat-icon>
      {{'my_play_conf' | GetLabelPipe}}
    </button>
    <hr>
  </ng-container>

  <!-- DEPRECATED -->
  <ng-container *ngIf="(application.isTrainerLogin() && [1178,1228,1167,1153,1152].includes(application.user.id))">
    <button mat-menu-item (click)="dispatchClassMenuEvent('generate_subscription')">
      <mat-icon>exposure_plus_1</mat-icon>
      {{'generate_subscription_event' | GetLabelPipe}}
    </button>
    <hr>
    <button mat-menu-item (click)="dispatchClassMenuEvent('send_group_message')">
      <mat-icon>message</mat-icon>
      {{'message' | GetLabelPipe}}
    </button>
    <hr>
  </ng-container>

  <ng-container *ngIf="classConfig?.type == 'smart_class' && (application.isOwnerLogin() || isClassOwner)">
    <button mat-menu-item (click)="dispatchClassMenuEvent('generate_subscription')">
      <mat-icon>exposure_plus_1</mat-icon>
      {{'generate_smart_subscription_event' | GetLabelPipe}}
    </button>
  </ng-container>

  <ng-container *ngIf="application.isTrainerLogin() && classConfig && classConfig['provide_play_config_on_join'] && (isClassOwner || profileClassRelation == 'active')">
    <button mat-menu-item (click)="dispatchClassMenuEvent('add_game_result')">
      <mat-icon>addchart</mat-icon>
      {{'add_game_result' | GetLabelPipe}}
    </button>
    <hr>
  </ng-container>

<!--  <ng-container *ngIf="isClassOwner || (!isClassOwner && profileClassRelation == 'active')">-->
<!--  </ng-container>-->

  <ng-container *ngIf="classConfig && classConfig['link']">
    <button mat-menu-item (click)="dispatchClassMenuEvent('more_info')">
      <mat-icon>info</mat-icon>
      {{'more' | GetLabelPipe}}
    </button>
    <hr>
    <button mat-menu-item (click)="dispatchClassMenuEvent('copy_link')">
      <mat-icon>share</mat-icon>
      {{'share_group_menu' | GetLabelPipe}}
    </button>
  </ng-container>

  <ng-container *ngIf="!isClassOwner && profileClassRelation == 'active'">
    <hr>
    <button mat-menu-item (click)="dispatchClassMenuEvent('exit_group')">
      <mat-icon>logout</mat-icon>
      {{'exit_group' | GetLabelPipe}}
    </button>
  </ng-container>
</mat-menu>

